// extracted by mini-css-extract-plugin
export default {"card":"LoyaltyProgramServiceCardMyCode_card__hk7CB","title":"LoyaltyProgramServiceCardMyCode_title__A0Jlu","titleHeight":"LoyaltyProgramServiceCardMyCode_titleHeight__JZD4l"};